function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWellbeingYellowLarge = function SvgWellbeingYellowLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.3111 15.4932L14.9058 30L3.50049 15.4932H9.43659C9.77008 15.4932 10.1369 15.2598 10.2703 14.993L12.0711 11.5247C12.2045 11.2912 12.538 11.2912 12.6714 11.5247L17.1402 20.1287C17.2736 20.3621 17.4737 20.4955 17.7071 20.4955C17.9406 20.4955 18.1406 20.3621 18.274 20.1287L20.5418 15.7267C20.6085 15.5933 20.7419 15.5266 20.9086 15.5266L26.3111 15.4932Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17017 14.4928C9.30357 14.4928 9.47031 14.4261 9.53701 14.2927L11.8047 9.89063C11.9381 9.65719 12.1382 9.52379 12.3717 9.52379C12.6051 9.52379 12.8052 9.65719 12.9386 9.89063L17.4073 18.4946C17.5407 18.7281 17.8742 18.7281 18.0076 18.4946L19.8085 15.0264C19.9419 14.7596 20.342 14.5261 20.6422 14.5261H27.1119L27.9122 13.4923C29.2462 11.8916 29.9799 9.79058 29.7464 7.48951C29.3796 3.48765 26.1114 0.286153 22.1095 0.0193622C19.1748 -0.180731 16.5069 1.18657 14.9062 3.35425C13.3054 1.18657 10.6375 -0.180731 7.70282 0.0193622C3.70096 0.286153 0.399418 3.48765 0.0325803 7.48951C-0.167513 9.75723 0.566162 11.8582 1.90012 13.459L2.70049 14.4928H9.17017Z",
    style: {
      fill: "var(--color-primary)"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWellbeingYellowLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wellbeing-yellow-large.72176b66.svg";
export { ForwardRef as ReactComponent };